import { render, staticRenderFns } from "./MenuLogotipo.vue?vue&type=template&id=5b3b946e&scoped=true"
import script from "./MenuLogotipo.vue?vue&type=script&lang=js"
export * from "./MenuLogotipo.vue?vue&type=script&lang=js"
import style0 from "./MenuLogotipo.vue?vue&type=style&index=0&id=5b3b946e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3b946e",
  null
  
)

export default component.exports